import { toInputName } from './toInputName';

export const stripField = (field: any) => {
  let strippedField: any = {};
  switch (field.type) {
    case 'divider':
      strippedField = {
        title: field.title,
      };
      break;
    case 'picker':
      strippedField = {
        label: field.label,
        description: field.description,
        items: field.items,
        isRequired: field.isRequired,
        isDisabled: field.isDisabled,
        isReadonly: field.isReadonly,
        value: field.value || '',
      };
      break;
    case 'title':
      strippedField = {
        title: field.title,
      };
      break;
    case 'signature':
      strippedField = {
        label: field.label,
        value: field.value || '',
      };
      break;
    case 'disclaimer':
      strippedField = {
        title: field.title,
        description: field.description,
        variant: field.variant,
      };
      break;
    case 'robeSizes':
      strippedField = {
        label: field.label,
        isDisabled: field.isDisabled,
        value: {
          xs: field.value?.xs || '',
          s: field.value?.s || '',
          m: field.value?.m || '',
          l: field.value?.l || '',
          xl: field.value?.xl || '',
          classMasterXS: field.value?.classMasterXS || '',
          classMasterS: field.value?.classMasterS || '',
          classMasterM: field.value?.classMasterM || '',
          classMasterL: field.value?.classMasterL || '',
        },
      };
      break;
    case 'infinite-list':
      strippedField = {
        label: field.label,
        inputs: field.inputs || [],
        diacritics: field.diacritics || [],
        autoCorrect: field.autoCorrect || [],
        value: field.value || [],
      };
      break;
    case 'multi-level-combobox':
      strippedField = {
        label: field.label,
        customInput: {
          selectedValues: field.customInput?.selectedValues || {},
          selectedValuesLabels: field.customInput?.selectedValuesLabels || {},
          properties: field.customInput?.properties || {},
          values: field.customInput?.values || [],
        },
        value: field.value || {},
      };
      break;
    case 'textarea':
    case 'text':
    case 'tel':
    case 'email':
    case 'datepicker':
      strippedField = {
        label: field.label,
        description: field.description,
        isRequired: field.isRequired,
        isDisabled: field.isDisabled,
        isReadonly: field.isReadonly,
        value: field.value || '',
        ...(field.type === 'datepicker' ? { dateMinValue: 'today' } : {}),
        ...(field.type === 'text' && field.diacritics
          ? { diacritics: field.diacritics }
          : {}),
        ...(field.type === 'textarea' && field.autoCorrect
          ? { autoCorrect: field.autoCorrect }
          : {}),
      };
      break;
    case 'map':
      strippedField = {
        label: field.label,
        name: field.name,
        description: field.description,
        isRequired: field.isRequired,
        isDisabled: field.isDisabled,
        value: field.value || null,
      };
      break;
    case 'products':
      strippedField = {
        label: field.label,
        isDisabled: field.isDisabled,
        value: field.value || [],
      };
      break;
    case 'imagePicker':
      strippedField = {
        label: field.label,
        description: field.description,
        availableImages: field.availableImages || [],
        maxSelection: field.maxSelection || 1,
        folderPath: field.folderPath || '',
        imagesAutoImport:
          field.imagesAutoImport !== undefined ? field.imagesAutoImport : true,
        isRequired: field.isRequired,
        isDisabled: field.isDisabled,
        isReadonly: field.isReadonly,
        value: field.value || [],
      };
      break;
    case 'checkboxGroup':
      strippedField = {
        label: field.label,
        description: field.description,
        items: field.items || [],
        isRequired: field.isRequired,
        isDisabled: field.isDisabled,
        isReadonly: field.isReadonly,
        value: field.value || [],
      };
      break;
    case 'radioButtonGroup':
      strippedField = {
        label: field.label,
        description: field.description,
        items: field.items || [],
        value: field.value,
      };
      break;
    default:
      strippedField = {};
  }

  const returnedField = {
    type: field.type,
    ...strippedField,
    name: toInputName(field.label || field.title || ''),
  };

  return returnedField;
};
